<template>
  <div class="below-container">
    <div class="friend-wrap">
      <div class="friend-category">
        <!-- <el-tabs type="card" v-model="activeName" :stretch="true">
            <el-tab-pane label="外部好友" name="first" ></el-tab-pane>
          </el-tabs> -->
        <div class="card">
          <div>外部好友</div>
        </div>
      </div>
      <div class="friend-name-list">
        <div class="masking" v-if="!isRequestSuccess"></div>
        <div
          class="empty-wrap"
          v-if="totals === 0 && !dataList.length && !loading"
        >
          暂无数据
        </div>
      </div>
    </div>
    <div style="flex: 6;">
      <ChatType
        v-bind:idData="idSet"
        :chatType="'employees'"
        @requestSuccess="requestSuccess"
      />
    </div>
  </div>
</template>
<script>
import ChatType from "./ChatType";
import { getAuthUserCustomerList } from "@/api/staff/staff.js";
import { getAgentConfig } from "@/utils/common"; //注入应用的权限
import {
  register,
  initOpenData,
  createOpenDataFrameFactory,
  createScrollViewContext,
} from "@/utils/wecom.cjs.js"; // 企微的api，目前npm下载和cdn引入都会出现api不全的情况，只能通过将包下载到本地进行应用，后续企微如修复可以使用其他方式（2024.06.14）
import sha1 from "sha1"; //签名加密
let that;
export default {
  name: "SelectExternalFriend",
  props: {
    // 员工 uid
    uid: {
      type: String,
      default: "",
      required: true,
    },
  },
  components: {
    ChatType,
  },
  data() {
    return {
      dataParam: {
        sendFrom: this.uid,
        startTime: "",
        endTime: "",
        current: 1,
        size: 999999,
        total: 0,
        name: "",
        /** 弹窗的加载实例 */
        dialogLoadingInstance: null,
      },
      // datechushi: [],
      dataList: [],
      // activeName: 'first',
      // msgSort: 'all' ,
      loading: false,
      radio: "",
      // cid: '',
      idSet: [],
      /** 是否新版会话存档 */
      isNewEdition: true,
      /** 请求是否完成 */
      isRequestSuccess: true,
      /** 提示实例，防止弹出多个提示 */
      messageInstance: null,
      instance: null,
      totals: 0,
    };
  },
  methods: {
    // 获取外部好友数据
    async getContactList(param) {
      this.idSet = [];
      this.loading = true;
      this.$emit("requestSuccess", this.loading);
      // 新版走这里
      if (this.isNewEdition) {
        if (this.dialogLoadingInstance) this.dialogLoadingInstance.close();
        this.dialogLoadingInstance = this.$loading({
          target: ".friend-name-list",
          text: "拼命加载中...",
        });
        await getAuthUserCustomerList(
          param,
          localStorage.getItem("Authorization"),
          true
        )
          .then((res) => {
            // this.datechushi = this.dataList = res.data.result;
            if (res && res.error && res.error.code == 200) {
              this.dataList = res.data.result;
              this.totals = res.data.totals;
              //             this.dataList = [{
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "wmHiy3CAAA6EPXDqE9sDZmgqpE4CNIxg",
              //             },
              //             {
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "wmHiy3CAAA6EPXDqE9sDZmgqpE4CNIxg",
              //             },
              //             {
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "wmHiy3CAAA6EPXDqE9sDZmgqpE4CNIxg",
              //             },
              //             {
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "wmHiy3CAAA6EPXDqE9sDZmgqpE4CNIxg",
              //             },
              //             {
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "wmHiy3CAAA6EPXDqE9sDZmgqpE4CNIxg",
              //             },
              //             {
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "wmHiy3CAAA6EPXDqE9sDZmgqpE4CNIxg",
              //             },
              //             {
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "wmHiy3CAAA6EPXDqE9sDZmgqpE4CNIxg",
              //             },
              //             {
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "wmHiy3CAAA6EPXDqE9sDZmgqpE4CNIxg",
              //             },
              //             {
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "wmHiy3CAAA6EPXDqE9sDZmgqpE4CNIxg",
              //             },{
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "wmHiy3CAAA6EPXDqE9sDZmgqpE4CNIxg",
              //             }
              //           ,{
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "woHiy3CAAAYPpbh7jmEQ3kNvfay_i5og",
              //             },{
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "wmHiy3CAAABpiyKiWQC3s4_J4wAplakQ",
              //             }
              //           ,{
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "wmHiy3CAAABpiyKiWQC3s4_J4wAplakQ",
              //             },
              //             {
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "wmHiy3CAAA6EPXDqE9sDZmgqpE4CNIxg",
              //             },
              //             {
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "woHiy3CAAAO7q7u8uxZs3l07Onng36wQ",
              //             },
              //             {
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "woHiy3CAAAYPpbh7jmEQ3kNvfay_i5og",
              //             },
              //             {
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "woHiy3CAAAYPpbh7jmEQ3kNvfay_i5og",
              //             },
              //             {
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "woHiy3CAAAYPpbh7jmEQ3kNvfay_i5og",
              //             },
              //             {
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "woHiy3CAAAYPpbh7jmEQ3kNvfay_i5og",
              //             },{
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "woHiy3CAAAO7q7u8uxZs3l07Onng36wQ",
              //             }
              //             ,{
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "woHiy3CAAAYPpbh7jmEQ3kNvfay_i5og",
              //             }
              //             ,{
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "woHiy3CAAAYPpbh7jmEQ3kNvfay_i5og",
              //             }
              //             ,{
              //               access
              // :
              // false,
              // dateStr
              // :
              // "2024-06-16",
              // departmentId
              // :
              // null,
              // departmentName
              // :
              // null,
              // id
              // :
              // 1,
              // name
              // :
              // null,
              // uid
              // :
              // "woHiy3CAAAO7q7u8uxZs3l07Onng36wQ",
              //             }

              //           ]

              this.dataParam.total = res.data.total || res.data.result.length;
            } else {
              if (this.messageInstance) this.messageInstance.close();
              this.messageInstance = this.$message.error(
                "获取失败，请稍后再试"
              );
            }
            this.dialogLoadingInstance
              ? this.dialogLoadingInstance.close()
              : "";
            this.loading = false;
            this.$emit("requestSuccess", this.loading);
          })
          .catch((err) => {
            this.loading = false;
            this.dialogLoadingInstance
              ? this.dialogLoadingInstance.close()
              : "";
            if (this.messageInstance) this.messageInstance.close();
            this.messageInstance = this.$message.error("获取失败，请稍后再试");
            this.$emit("requestSuccess", this.loading);
            console.log(err, "errr");
          });
      }
    },

    // 点击当前分页
    // handleCurrentChange(parm) {
    //   this.getContactList(this.dataParam);
    // },

    async displayContact(uid, startTime, endTime, radio) {
      this.dataParam.sendFrom = uid;
      this.dataParam.startTime = startTime;
      this.dataParam.endTime = endTime;
      this.dataParam.current = 1;
      this.radio = radio;
      if (that.instance) {
        that.instance.setData({
          dataList: [],
          currentId: "",
        });
        await that.getContactList(this.dataParam);
        if (that.instance) {
          that.instance.setData({
            dataList: this.dataList,
          });
        }
        this.idSet = [];
      } else {
        if (this.messageInstance) this.messageInstance.close();
        this.dialogLoadingInstance = this.$loading({
          target: ".friend-name-list",
          text: "拼命加载中...",
        });
        await that.getContactList(this.dataParam);
        if (!this.dataList.length) return;
        // this.getContactList(this.dataParam)
        getAgentConfig(localStorage.getItem("Authorization"))
          .then(async () => {
            await this.registerInformation();

            // 这里必须用定时器延迟一下，不然可能会出现加载不出来的问题
            setTimeout(() => {
              // that.getContactList(this.dataParam);
              if (that.instance) {
                that.instance.setData({
                  dataList: this.dataList,
                });
              }
            }, 500);
          })
          .catch((err) => {
            this.$message.error("获取失败，请稍后再试");
          });
        this.idSet = [];
      }
    },

    /** 注册应用信息 */
    async registerInformation() {
      let enterpriseData = JSON.parse(
        window.localStorage.getItem("enterpriseData")
      );
      // 初始化应用信息
      register({
        corpId: enterpriseData.corpid,
        agentId: enterpriseData.agentid,
        jsApiList: [
          "selectExternalContact",
          "shareAppMessage",
          "wwapp.invokeJsApiByCallInfo",
        ],
        getAgentConfigSignature: async (url) => {
          console.log("dfssdfdsfsd", url);
          let timestamp = Date.parse(new Date()) / 1000;
          let nonceStr = this.randomString(17);
          let signature = sha1(
            `jsapi_ticket=${enterpriseData.ticket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${url}`
          );
          return { timestamp, nonceStr, signature };
        },
        onAgentConfigSuccess: (res) => {
          console.log("res++++++++++", res);
        },
        onAgentConfigFail: (res) => {
          this.$message.error("初始化失败，请稍后再试");
          console.log("res1++++++++++", res);
        },
      });
      // 会话组件需要确保 WWOpenData 初始化成功
      await initOpenData();
      //
      this.getComponents();
    },

    /** 获取展示组件工厂对象 */
    async getComponents() {
      // 创建“展示组件工厂”对象备用：
      this.factory = await createOpenDataFrameFactory();
      this.getSessioInstance();
    },

    /** 随着字串 */
    randomString(len) {
      len = len || 32;
      var $chars =
        "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
      var maxPos = $chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    /** 生成会话组件实例 */
    async getSessioInstance() {
      this.instance = await this.factory.createOpenDataFrame({
        // “容器”元素，用于挂载展示组件
        el: ".friend-name-list",
        // html
        template: `
          <scroll-view  
           class="scroll-wrap" 
           scroll-y
           ref="scrollRef" 
           lower-threshold={{0}}
           scroll-top="{{data.scrollTop}}"
           bindscrolltolower="onScrollLower" 
           binderror="onOpenMsgError"
           >
           <view class="list">
              <view
                wx:for="{{data.dataList}}"
                wx:key="msgid"
                data-index="{{index}}" data-uid="{{item.uid}}"  bindclick="selectExternalFriend" class="{{data.currentId === item.uid ? 'user-list-item selected-style' : 'user-list-item'}}">
                <ww-suspense>
                <ww-open-data type="externalUserName"  class="" openid="{{item.uid}}"/>
                <block wx:slot="fallback">
                  <view class="msgCnt-fallback">消息内容正在加载...</view>
                </block>
                <view class="last-chat-date">{{item.dateStr}}</view>
              </ww-suspense>
              </view>
            </view>
          </scroll-view>
    `,
        // css
        style: `
    .scroll-wrap{
       height:100%;
       position: relative;
     }

     .list{
      height:100%;
      width:100%;
     }

     .user-list-item{
        cursor: pointer;
        padding:16px 10px;
        border-bottom: 1px solid #F4F6F9;
        display:flex;
        align-items: center;
        justify-content: space-between;
        font-size:16px;
        box-sizing: border-box;
        
     }
     .last-chat-date{
        color:#ccc;
        font-size:12px;
        flex-shrink:0;
     }
     .scroll-wrap{
        scrollbar-width: none; 
        -ms-overflow-style: none;
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
        overflow-x: hidden;
        overflow-y: auto;
     }
     .scroll-wrap::-webkit-scrollbar {
        display: none; /* Chrome Safari */  
      }
      .masking {
        width: 100%;
        height:100%;
        background-color: #ccc;
        position: absolute;
        z-index: 9999;
        opacity: 0.3;
      } 
      .selected-style {
        background-color:#ECF5FF;
      }
      .friend-item-wrap{
          cursor: pointer;
      }
     `,
        // 数据源
        data: {
          dataList: [],
          // tip: "加载更多...",
          tip: "没有更多数据了",
          scrollTop: 0,
          flag: true,
          totals: 0,
          isRequestSuccess: true,
          /** 当前选中的id */
          currentId: "",
        },

        // 方法
        methods: {
          /** 滚动到底部触发 */
          onScrollLower() {
            console.log("触底了", this.data.dataList);
            // if (!(this.data.dataList.length >= that.pageInfo.totals)) {
            //   // if (this.data.flag) {
            //   //   that.instance.setData({
            //   //     flag: false
            //   //   })
            //   //   that.pageInfo.current++
            //   //   that.getDataList()
            //   // }
            //   // setTimeout(() => {
            //   //   that.instance.setData({
            //   //     flag: true
            //   //   })
            //   // }, 1000)
            //   that.pageInfo.current++
            //   that.getDataList()
            // } else {
            //   if (that.instance) {
            //     that.instance.setData({
            //       tip: "没有更多数据了"
            //     })
            //   }
            // }
          },

          // 选中行
          selectExternalFriend(val) {
            console.log("val++++", val.currentTarget.dataset.uid);
            // 选中人员时把选中的id赋给当前id，改变样式
            if (that.instance) {
              that.instance.setData({
                currentId: val.currentTarget.dataset.uid,
              });
            }
            // 把选中的id传给子组件
            that.idSet = [
              that.dataParam?.sendFrom,
              val.currentTarget?.dataset?.uid,
            ];
          },

          /** 失败触发 */
          onOpenMsgError(event) {
            // 用户在使用过程中，常见的异常状态为 “当前登录态过期”，此时需要服务商引导用户重新进行扫码登录。
            // “登录态异常”的出现时机有两个：
            // 初始化 openDataFrame 流程中，登录态已经失效；
            // 初始化成功后，长时间使用未重新登录，登录态已经失效；
            // 错误事件会在 createOpenDataFrame 的 error 回调中返回，有两种错误特征：
            // 浏览器判断登录过期后自动删除票据，特征为 errMsg 为 “Missing open sid”：
            // 后台判断登录态过期，特征为 errCode 为 42006：
            if (
              (event && event.errCode === "42006") ||
              event.errMsg === "Missing open sid"
            ) {
              this.$message("登录状态失效，请重新登录");
            }
            // 使用过程，登录态失效出错,错误事件会在 ww-xxx 组件的 binderr 回调中返回，错误特征为：detail.errCode 为 42003 或者 40029：
            if (
              (event && event.detail.errCode === "42003") ||
              event.detail.errCode === "40029"
            ) {
              this.$message("登录态失效或出错，请重新登录");
            }
            console.warn("open message error: ", event);
          },
        },

        /** 视图挂载成功后的回调 */
        handleMounted() {
          // 挂载成功后才能获取聊天数据
        },
        /** 视图更新成功后的回调 */
        handleUpdated() {},
      });
    },

    // 计算日期
    displayTimeStr(timeStr) {
      var day = new Date(timeStr).getDay();
      var time = new Date(timeStr).getTime();
      var timeNow = Date.parse(new Date());

      var timeDiffer = timeNow - time;
      if (timeDiffer <= 60000) {
        //一分钟内
        var returnTime = "刚刚";
      } else if (
        timeDiffer > 60000 &&
        timeDiffer < 86400000 &&
        this.isYesterday(time) === false
      ) {
        //今日
        var returnTime = "今天";
      } else if (timeDiffer > 60000 && this.isYesterday(time) === true) {
        //昨天
        var returnTime = "昨天";
      } else if (timeDiffer >= 86400000 && timeDiffer < 60000 * 60 * 24 * 6) {
        var returnTime = "星期" + "日一二三四五六".charAt(day);
      } else var returnTime = timeStr;

      return returnTime;
    },

    // 是否昨天
    isYesterday(time) {
      var today = new Date();
      var yesterday = new Date(today - 1000 * 60 * 60 * 24);
      var test = new Date(time);
      if (
        yesterday.getYear() === test.getYear() &&
        yesterday.getMonth() === test.getMonth() &&
        yesterday.getDate() === test.getDate()
      ) {
        return true;
      } else {
        return false;
      }
    },

    /** 获取当天日期 */
    getToday() {
      var date = new Date();
      var y = date.getFullYear();
      var m =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return y + "-" + m + "-" + d;
    },

    // 由子组件触发，请求完成触发，触发后在次通知父组件
    requestSuccess(val) {
      this.isRequestSuccess = val;
      if (that.instance) {
        that.instance.setData({
          isRequestSuccess: that.isRequestSuccess,
        });
      }
      this.$emit("requestSuccess", !this.isRequestSuccess);
    },
  },
  created() {
    that = this;
  },
};
</script>
<style lang="scss" scoped>
.below-container {
  width: 100%;
  height: 60vh;
  display: flex;
  justify-content: space-around;

  .common-class {
    width: 100% !important;
    height: 100% !important;
  }

  .friend-wrap {
    // flex: 4;
    display: flex;
    flex-direction: column;
    // min-width: 200px;
    width: 200px;

    .friend-category {
      width: 100%;

      .card {
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-bottom: 1px solid #e4e7ed;
      }

      /deep/.el-tabs__header {
        margin: 0 !important;

        .el-tabs__item.is-active {
          border-bottom: none !important;
        }

        .el-tabs__nav {
          border: none !important;
        }

        .el-tabs__item {
          border-left: none;
          border-right: 1px solid #e4e7ed;
        }
      }
    }

    .friend-name-list {
      height: 100%;
      position: relative;

      .masking {
        width: 100%;
        height: 100%;
        background-color: #ccc;
        position: absolute;
        z-index: 9999;
        opacity: 0.3;
      }

      .empty-wrap {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #909399;
        position: absolute;
        width: 100%;
        z-index: 99999;
      }
    }

    // .friend-name-list {
    //   flex: 1;
    //   position: relative;

    //   .masking {
    //     width: 100%;
    //     height: 100%;
    //     background-color: #ccc;
    //     position: absolute;
    //     z-index: 9999;
    //     opacity: 0.3;
    //   }

    //   // /deep/ .el-scrollbar__view {
    //   //   width: 100% !important;
    //   //   height: 100% !important;
    //   // }

    //   // /deep/ .is-scrolling-none {
    //   //   width: 100% !important;
    //   //   height: 100% !important;
    //   //   flex: 1;
    //   // }

    //   .friend-aside {
    //     display: flex;
    //     flex-direction: column;

    //     .el-table--fit {
    //       width: 100% !important;
    //       height: 100% !important;
    //       display: flex;
    //       flex-direction: column;
    //     }
    //   }
    // }
  }
}

::v-deep iframe {
  height: 100%;
  overflow: hidden;
  width: 100%;
}
</style>
